<template>
  <BusyButton
    variant="secondary"
    expanded
    :disabled="isAnyLoading"
    :is-loading="isLoading"
    :aria-label="isLoading ? 'Adding to bag for checkout...' : 'Buy Now'"
    @click="mutate({ buynow: true })"
  >
    Buy Now
  </BusyButton>
</template>

<script setup>
import { watch, watchEffect } from 'vue';
import BusyButton from '~/modules/ui/components/BusyButton';

import { useAddToBag } from '../composables/useAddToBag';

const props = defineProps({
  payload: {
    /**
     * @type {import('vue').PropType<import('../types').ATBPayload>}
     */
    type: Object,
    required: true,
  },
  payloadValidator: {
    /**
     * ? That's not the best option to pass function as prop.
     * ? It's trade off between reausablity and Vue conceptions
     * @type {import('vue').PropType<import('../types').ATBPayloadValidator>}
     */
    type: Function,
    required: false,
    default: () => null,
  },
});

const emits = defineEmits(['error', 'bag-loaded']);

const { isLoading, isAnyLoading, mutate, error } = useAddToBag(
  {
    payload: () => props.payload,
    payloadValidator: props.payloadValidator,
  },
  {
    checkoutRedirect: true,
  },
);

watchEffect(() => {
  emits('error', error.value);
});

watch(
  () => isLoading.value,
  (val) => {
    if (val) return;

    emits('bag-loaded');
  },
);
defineExpose({
  isLoading,
});
</script>
